import React from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'
import {useFilterDescriptions} from 'hooks/useFilterDescriptions'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {FilterUrlParams} from 'modules/search/types'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Pill} from '@vio/atlas/Pill'

interface Props
  extends Pick<
    ReturnType<typeof useFiltersForm>,
    'toggleMultiFilter' | 'toggleFilters'
  > {
  filters: FilterUrlParams
  appliedFilters: FilterUrlParams
}

const IconContainer = styled(Icon)`
  transition: rotate 0.15s ease-in-out;
  &.--selected {
    rotate: -45deg;
  }
`

export const useSelectedFilterItems = ({
  filters,
  appliedFilters,
  toggleMultiFilter,
  toggleFilters
}: Props) => {
  const descriptions = useFilterDescriptions({filters, appliedFilters})

  return descriptions.map(({change, ...description}) => ({
    ...description,
    onClick: () => {
      if ('key' in change) {
        toggleMultiFilter(change.key, change.value)
      } else {
        toggleFilters(change.filters)
      }
    }
  }))
}

const SelectedFiltersComponent: React.FC<Props> = props => {
  const selectedFiltersList = useSelectedFilterItems(props)

  return (
    <Box display="flex" columnGap="s300" rowGap="s300" flexWrap="wrap">
      {selectedFiltersList.map(filter => (
        <Pill
          size="lg"
          key={filter.id}
          isSelected={filter.isSelected}
          iconStart={filter.iconStart}
          iconEnd={
            <IconContainer
              className={cx(filter.isSelected && '--selected')}
              name={'Plus'}
            />
          }
          onClick={filter.onClick}
        >
          {filter.label}
        </Pill>
      ))}
    </Box>
  )
}

export const SelectedFilters = React.memo(SelectedFiltersComponent)
